export interface MeatProduct {
  id: string;
  nameKey: string;
  descKey: string;
  category: 'res' | 'cerdo' | 'pollo' | 'mariscos' | 'chivo' | 'embutidos';
  price: number;
  priceUnit: string;
  weight: string;
  origin: string;
  image: string;
  badgeKey?: string;
}

export const meatCategories = [
  { id: 'todos', labelKey: 'cat_all' },
  { id: 'res', labelKey: 'cat_beef' },
  { id: 'cerdo', labelKey: 'cat_pork' },
  { id: 'pollo', labelKey: 'cat_chicken' },
  { id: 'chivo', labelKey: 'cat_goat' },
  { id: 'mariscos', labelKey: 'cat_seafood' },
] as const;

export const meatProducts: MeatProduct[] = [
  // RED MEAT / CARNE ROJA (disponibles)
  {
    id: '1',
    nameKey: 'prod_costilla_res',
    descKey: 'desc_costilla_res',
    category: 'res',
    price: 8.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20beef%20short%20ribs%20bone%20in%20on%20butcher%20paper%20rustic%20wood%20background%20professional%20food%20photography%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat1&orientation=squarish',
    badgeKey: 'badge_popular',
  },
  {
    id: '2',
    nameKey: 'prod_rabo',
    descKey: 'desc_rabo',
    category: 'res',
    price: 12.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20oxtail%20beef%20tail%20sections%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20style%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat2&orientation=squarish',
  },
  {
    id: '3',
    nameKey: 'prod_costilla_cerdo',
    descKey: 'desc_costilla_cerdo',
    category: 'cerdo',
    price: 6.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20pork%20ribs%20rack%20on%20butcher%20paper%20wood%20background%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat3&orientation=squarish',
  },
  {
    id: '4',
    nameKey: 'prod_pernil',
    descKey: 'desc_pernil',
    category: 'cerdo',
    price: 5.99,
    priceUnit: 'lb',
    weight: 'Pierna entera',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20pork%20shoulder%20pernil%20whole%20leg%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20style%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat4&orientation=squarish',
    badgeKey: 'badge_best_seller',
  },
  {
    id: '5',
    nameKey: 'prod_pata_vaca',
    descKey: 'desc_pata_vaca',
    category: 'res',
    price: 5.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20beef%20shank%20osso%20buco%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat5&orientation=squarish',
  },
  {
    id: '6',
    nameKey: 'prod_bistec',
    descKey: 'desc_bistec',
    category: 'res',
    price: 9.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20beef%20top%20round%20steak%20sliced%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat6&orientation=squarish',
  },
  {
    id: '7',
    nameKey: 'prod_carne_molida',
    descKey: 'desc_carne_molida',
    category: 'res',
    price: 5.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=ground%20beef%20raw%20in%20butcher%20paper%20on%20wood%20surface%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat7&orientation=squarish',
  },
  {
    id: '8',
    nameKey: 'prod_chuleta',
    descKey: 'desc_chuleta',
    category: 'cerdo',
    price: 6.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20pork%20chops%20bone%20in%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat8&orientation=squarish',
  },
  {
    id: '9',
    nameKey: 'prod_chivo',
    descKey: 'desc_chivo',
    category: 'chivo',
    price: 10.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20goat%20meat%20pieces%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat9&orientation=squarish',
    badgeKey: 'badge_specialty',
  },
  {
    id: '10',
    nameKey: 'prod_bola_res',
    descKey: 'desc_bola_res',
    category: 'res',
    price: 8.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20beef%20round%20roast%20whole%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat10&orientation=squarish',
  },
  {
    id: '11',
    nameKey: 'prod_mondongo',
    descKey: 'desc_mondongo',
    category: 'res',
    price: 6.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20beef%20tripe%20mondongo%20on%20metal%20tray%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat11&orientation=squarish',
  },
  {
    id: '12',
    nameKey: 'prod_orejita',
    descKey: 'desc_orejita',
    category: 'cerdo',
    price: 4.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20pork%20ears%20whole%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat12&orientation=squarish',
  },
  {
    id: '13',
    nameKey: 'prod_higado',
    descKey: 'desc_higado',
    category: 'res',
    price: 3.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20beef%20liver%20slices%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat13&orientation=squarish',
  },
  {
    id: '14',
    nameKey: 'prod_masita',
    descKey: 'desc_masita',
    category: 'cerdo',
    price: 6.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20pork%20chunks%20masitas%20cubed%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat14&orientation=squarish',
  },
  {
    id: '15',
    nameKey: 'prod_chicharron',
    descKey: 'desc_chicharron',
    category: 'cerdo',
    price: 7.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=pork%20rinds%20chicharron%20crispy%20fried%20pieces%20on%20wooden%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat15&orientation=squarish',
    badgeKey: 'badge_fresh',
  },
  {
    id: '16',
    nameKey: 'prod_churrasco',
    descKey: 'desc_churrasco',
    category: 'res',
    price: 14.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20skirt%20steak%20churrasco%20long%20thin%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat16&orientation=squarish',
  },
  // POULTRY / AVES
  {
    id: '17',
    nameKey: 'prod_pechuga',
    descKey: 'desc_pechuga',
    category: 'pollo',
    price: 3.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20chicken%20breast%20boneless%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat17&orientation=squarish',
  },
  {
    id: '18',
    nameKey: 'prod_ala_pollo',
    descKey: 'desc_ala_pollo',
    category: 'pollo',
    price: 2.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20chicken%20wings%20on%20metal%20tray%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat18&orientation=squarish',
  },
  {
    id: '19',
    nameKey: 'prod_gallina',
    descKey: 'desc_gallina',
    category: 'pollo',
    price: 4.99,
    priceUnit: 'lb',
    weight: 'Entera',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=whole%20raw%20hen%20chicken%20on%20wooden%20surface%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat19&orientation=squarish',
  },
  {
    id: '20',
    nameKey: 'prod_muslo',
    descKey: 'desc_muslo',
    category: 'pollo',
    price: 2.99,
    priceUnit: 'lb',
    weight: 'Con hueso',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20chicken%20leg%20quarters%20bone%20in%20on%20metal%20tray%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat20&orientation=squarish',
  },
  {
    id: '21',
    nameKey: 'prod_pollo_entero',
    descKey: 'desc_pollo_entero',
    category: 'pollo',
    price: 3.49,
    priceUnit: 'lb',
    weight: 'Entero',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=whole%20raw%20chicken%20on%20wooden%20surface%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat21&orientation=squarish',
  },
  {
    id: '22',
    nameKey: 'prod_molleja',
    descKey: 'desc_molleja',
    category: 'pollo',
    price: 3.99,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20chicken%20gizzards%20on%20metal%20tray%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat22&orientation=squarish',
  },
  {
    id: '23',
    nameKey: 'prod_ala_pavo',
    descKey: 'desc_ala_pavo',
    category: 'pollo',
    price: 3.49,
    priceUnit: 'lb',
    weight: 'Por libra',
    origin: 'USA',
    image: 'https://readdy.ai/api/search-image?query=raw%20turkey%20wings%20on%20metal%20tray%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat23&orientation=squarish',
  },
  // SEAFOOD / MARISCOS
  {
    id: '24',
    nameKey: 'prod_basa',
    descKey: 'desc_basa',
    category: 'mariscos',
    price: 7.99,
    priceUnit: 'lb',
    weight: 'Filete',
    origin: 'Importado',
    image: 'https://readdy.ai/api/search-image?query=raw%20basa%20fish%20fillets%20on%20wooden%20cutting%20board%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat24&orientation=squarish',
  },
  {
    id: '25',
    nameKey: 'prod_pescado',
    descKey: 'desc_pescado',
    category: 'mariscos',
    price: 5.99,
    priceUnit: 'lb',
    weight: 'Entero',
    origin: 'Importado',
    image: 'https://readdy.ai/api/search-image?query=whole%20raw%20fish%20on%20metal%20tray%20professional%20food%20photography%20rustic%20high%20quality%20warm%20lighting&width=400&height=400&seq=meat25&orientation=squarish',
  },
];

export interface Testimonial {
  id: string;
  name: string;
  role: string;
  textKey: string;
  rating: number;
  avatar: string;
}

export const testimonials: Testimonial[] = [
  {
    id: '1',
    name: 'María Rodríguez',
    role: 'Cliente Frecuente',
    textKey: 'testimonial_1_text',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=latina%20woman%20portrait%20headshot%20warm%20smile%20professional%20look%20neutral%20background%20studio%20lighting&width=80&height=80&seq=avatar1&orientation=squarish',
  },
  {
    id: '2',
    name: 'José Hernández',
    role: 'Chef de Restaurante Dominicano',
    textKey: 'testimonial_2_text',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=hispanic%20man%20portrait%20headshot%20chef%20uniform%20confident%20smile%20neutral%20background%20studio%20lighting&width=80&height=80&seq=avatar2&orientation=squarish',
  },
  {
    id: '3',
    name: 'Carmen López',
    role: 'Ama de Casa',
    textKey: 'testimonial_3_text',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=latina%20woman%20portrait%20headshot%20mature%20kind%20smile%20neutral%20background%20studio%20lighting&width=80&height=80&seq=avatar3&orientation=squarish',
  },
  {
    id: '4',
    name: 'Pedro Santos',
    role: 'Parrillero de Fiestas',
    textKey: 'testimonial_4_text',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=puerto%20rican%20man%20portrait%20headshot%20casual%20style%20confident%20smile%20neutral%20background%20studio%20lighting&width=80&height=80&seq=avatar4&orientation=squarish',
  },
  {
    id: '5',
    name: 'Ana García',
    role: 'Cocinera Catering',
    textKey: 'testimonial_5_text',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=dominican%20woman%20portrait%20headshot%20professional%20style%20warm%20smile%20neutral%20background%20studio%20lighting&width=80&height=80&seq=avatar5&orientation=squarish',
  },
  {
    id: '6',
    name: 'Roberto Cruz',
    role: 'Cliente Frecuente',
    textKey: 'testimonial_6_text',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=hispanic%20middle%20aged%20man%20portrait%20headshot%20friendly%20smile%20neutral%20background%20studio%20lighting&width=80&height=80&seq=avatar6&orientation=squarish',
  },
];